import React, { Component } from "react";
import ReactDOM from "react-dom";
// import { connect } from "react-redux";
// import { noMixedBankDataComp } from "../../actions";
// import { bindActionCreators } from "redux";
// import { Grid, Divider, Portal } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import api from "../../config/api";
import logoPrefeituraPomba from "../../assets/img/logo-prefeitura-pomba.png";
import ReportsNonMixedBanksComponent from "../../components/ReportsNonMixedBanksComponent";

const styles = (theme) => ({
  container: {
    justifyContent: "center",
  },
  main: {
    maxWidth: 600,
  },
  printButton: {
    margin: "20px auto",
    display: "flex",
  },
  borderItem: {
    padding: 35,
    border: "1px solid #00000033",
  },
  header: {
    display: "flex",
    justifyContent: "space-around",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  headerImg: {
    width: 100,
    height: 100,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    padding: "10px 0 30px 0",
  },
  contentTitle: {
    fontSize: 25,
    fontWeight: 500,
  },
  contentDescription: {
    fontSize: 21,
    fontWeight: 500,
  },
  dataReportItem: {
    margin: 4,
  },
  bankItem: {
    display: "flex",
    alignItems: "center",
    margin: 2,
  },
  dot: {
    width: 5,
    height: 5,
    marginRight: 6,
    background: "#000",
    borderRadius: "50%",
  },
  divider: {
    width: "100%",
  },
});

export class ReportsNonMixedBanks extends Component {
  state = {
    banksList: [],
  };

  componentDidMount() {
    document.body.style.backgroundColor = "#fff";
    this.externalWindow = window.open(
      "",
      "",
      "width=600,height=400,left=200,top=200"
    );
    this.containerEl = this.externalWindow.document.createElement("div");
    this.externalWindow.document.body.appendChild(this.containerEl);
      api
      .get("Bancos/Consultar?opcao=2")
      .then((banksGroup) => {
        if (banksGroup.data.length > 0) {
          const banks = banksGroup.data.filter(
            (item) => item.PermiteDebitoAutomatico === true
          );
          this.setState({
            banksList: banks,
          });
        }
      })
      .catch((error) => {
        if (error.response.status >= 500) {
          this.setState({
            error:
              "Servidor indisponível no momento, tente novamente mais tarde",
            loading: false,
          });
        } else if (error.response.status === 404) {
          this.setState({
            error: "Item não encontrado",
            loading: false,
          });
        } else {
          this.setState({
            error: error.response.data.error_description,
            loading: false,
          });
        }
      });
  }

  componentWillUnmount() {
    this.externalWindow.close();
  }

  render() {
    if (!this.containerEl) {
      return null;
    }
    return ReactDOM.createPortal(
      <ReportsNonMixedBanksComponent
        logoPrefeituraPomba={logoPrefeituraPomba}
      />,
      this.containerEl
    );
  }
}

export default withStyles(styles, { withTheme: true })(ReportsNonMixedBanks);
